const projList = [
    {
        "name": "esd",
        "title": "IS213 Enterprise Solution Development Project: ESDeezKnee",
        "date": "Jan 2023 to Apr 2023",
        "image1": "/src/assets/esd.jpeg",
        "image2": "",
        "video": "https://youtu.be/Hvxrg_qIf7g",
        "link": "https://github.com/ESDeezknee/ESDeezknee",
        "linkLabel": "Github",
        "responsibilities": "", 
        "description": "An immersive enterprise solution that offers a wide range of functions through the application for theme parks to utilise and engage with their visitors.",
        "skills": "Flask, Docker, MySQL, Postman, RabbitMQ, NotificationsAPI"
    },
    {
        "name": "wad2",
        "title": "IS216 Web Application Development II Project: Concord",
        "date": "Aug 2022 to Dec 2022",
        "image1": "/src/assets/wad2.jpeg",
        "image2": "",
        "video": "",
        "link": "https://github.com/zacharylian/IS216G6T1",
        "linkLabel": "Github",
        "responsibilities": "",
        "description": "A web application that aims to integrate task management, scheduling, and expense-tracking into one productivity master-app. ",
        "skills": "VueJS, SCSS, ChartJS, D3.js, Firebase(JSON), SweetAlert2"
    },
    {
        "name": "heap",
        "title": ".Hack Enrichment Application Program (HEAP): HeresOurPlan",
        "date": "May 2022 to Aug 2022",
        "image1": "/src/assets/heap.png",
        "image2": "",
        "video": "https://youtu.be/pEVdiWy-Gek",
        "link": "https://github.com/HeresOurPlan",
        "linkLabel": "Github",
        "responsibilities": "",
        "description": " A mobile application that strives to provide a solution for its users in terms of itinerary planning.",
        "skills": "VueJS, Leaflet.JS, Flask, MySQL, Postman"
    },
    {
        "name": "dbtt",
        "title": "IS215 Digital Business Technologies and Transformation Project: FooDeTech",
        "date": "Jan 2023 to Apr 2023",
        "image1": "/src/assets/dbtt.jpeg",
        "image2": "",
        "video": "https://youtu.be/GeUQV8IKvLQ",
        "link": "https://github.com/zacharylian/dbtt",
        "linkLabel": "Github",
        "responsibilities": "",
        "description": "Reduce food waste generated by F&B establishments and improve food sustainability in Singapore. Conducted EDA using Matlplotlib, Seaborn and hvplot. Utilised 3 different regression models to make predictions of the spoiling rate of cooked chicken. Used computer vision to aid the camera feature of FooDeTech to better identify and determine the type and cooking method of food placed in front of the device.",
        "skills": "EDA, Pandas, Matplotlib, Seaborn, hvplot, Sci-kit Learn, Linear Regression, Random Forest, XGBoost, YOLOv5"
    },
    {
        "name": "dap",
        "title": "BIA Data Associate Program: Aspect Based Sentiment Analysis Project (ABSA)",
        "date": "Dec 2022 to May 2023",
        "image1": "/src/assets/dap.jpeg",
        "image2": "",
        "video": "",
        "link": "https://github.com/zacharylian/bi-pain",
        "linkLabel": "Github",
        "responsibilities": "",
        "description": "Performed data pre-processing and dependency annotating on an Amazon user review dataset for eCommerce applications. Trained a custom NER and dependency parse tree model to perform ABSA and opinion mining on the dataset and achieved an accuracy score of 0.527 and 0.861 respectively. Trained pre-trained models (PTMs) (BERT and RoBERTa) to perform ABSA and opinion mining on the SemEval-2016 dataset on Laptop Reviews and achieved our highest accuracy score of 0.824 ",
        "skills": "Sci-kit Learn, Pandas, Matplotlib, Seaborn, Jupyter, SpaCy, TextBlob, NLTK, BERT, RoBERTa"
    },
    {
        "name": "ai200",
        "title": "AI200: Applied Machine Learning Capstone Project",
        "date": "Dec 2021",
        "image1": "/src/assets/ai200.png",
        "image2": "",
        "video": "",
        "link": "",
        "linkLabel": "",
        "responsibilities": "",
        "description": "Trained a supervised ML model using a variety of boosting methods (XGBoost, CatBoost, AdaBoost) to identify online auction bids that are placed by “robots”, and finetuned each method to gain the most optimal accuracy and f1 score",
        "skills": "XGBoost, CatBoost, AdaBoost, Sci-kit Learn"
    },
]

export default projList